import { Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../../contexts/authWindows';
import { useTranslation } from '../../contexts/translation';

export function LogoutPage() {
  const navigate = useNavigate();
  const { signOut, user } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (!user) return;
  }, [user]);

  signOut && signOut();
  navigate(-1);
  return (
    <>
      {user && signOut && signOut()}
      <Typography>{t('general.messages.info.logging-out')}</Typography>
    </>
  );
}
